import { render, staticRenderFns } from "./checkupDisease.vue?vue&type=template&id=7542fc48"
import script from "./checkupDisease.vue?vue&type=script&lang=js"
export * from "./checkupDisease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7542fc48')) {
      api.createRecord('7542fc48', component.options)
    } else {
      api.reload('7542fc48', component.options)
    }
    module.hot.accept("./checkupDisease.vue?vue&type=template&id=7542fc48", function () {
      api.rerender('7542fc48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkupDisease.vue"
export default component.exports